<template>
    <v-container fluid>
        <v-layout row wrap>
            <v-flex md6>
                <v-text-field v-model="bumperToBumperWarrantyStart" label="Bumper to Bumper Warranty Start" disabled></v-text-field>
            </v-flex>
            <v-flex md6>
                <v-text-field v-model="bumperToBumperWarrantyEnd" label="Bumper to Bumper Warranty End" disabled></v-text-field>
            </v-flex>
        </v-layout>
        <v-layout row wrap>
            <v-flex md6>
                <v-text-field v-model="engineWarrantyStart" label="Engine Warranty Start" disabled></v-text-field>
            </v-flex>
            <v-flex md6>
                <v-text-field v-model="engineWarrantyEnd" label="Engine Warranty End" disabled></v-text-field>
            </v-flex>
        </v-layout>
        <v-layout row wrap>
            <v-flex md6>
                <v-text-field v-model="transmissionWarrantyStart" label="Transmission Warranty Start" disabled></v-text-field>
            </v-flex>
            <v-flex md6>
                <v-text-field v-model="transmissionWarrantyEnd" label="Transmission Warranty End" disabled></v-text-field>
            </v-flex>
        </v-layout>
        <v-layout row wrap>
            <v-flex md6>
                <v-text-field v-model="bodyWarrantyStart" label="Body Warranty Start" disabled></v-text-field>
            </v-flex>
            <v-flex md6>
                <v-text-field v-model="bodyWarrantyEnd" label="Body Warranty End" disabled></v-text-field>
            </v-flex>
        </v-layout>
        <v-layout row wrap>
            <v-flex md6>
                <v-text-field v-model="unit.subjectToCampaign" label="Subject To Extended Coverage" disabled></v-text-field>
            </v-flex>
        </v-layout>
        <v-layout row>
            <v-flex >
                <v-textarea v-model="unit.subjectToCampaignNotes" label="Extended Coverage Notes" disabled auto-grow :row-height="15"></v-textarea>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import moment from 'moment';

export default {
    props: {
        unit: {
            required: true
        }
    },
    computed: {
        bumperToBumperWarrantyStart() {
            return this.formatWarrantyDate(this.unit.bumperToBumperWarrantyStart);
        },
        bumperToBumperWarrantyEnd() {
            return this.formatWarrantyDate(this.unit.bumperToBumperWarrantyEnd);
        },
        engineWarrantyStart() {
            return this.formatWarrantyDate(this.unit.engineWarrantyStart);
        },
        engineWarrantyEnd() {
            return this.formatWarrantyDate(this.unit.engineWarrantyEnd);
        },
        transmissionWarrantyStart() {
            return this.formatWarrantyDate(this.unit.transmissionWarrantyStart);
        },
        transmissionWarrantyEnd() {
            return this.formatWarrantyDate(this.unit.transmissionWarrantyEnd);
        },
        bodyWarrantyStart() {
            return this.formatWarrantyDate(this.unit.bodyWarrantyStart);
        },
        bodyWarrantyEnd() {
            return this.formatWarrantyDate(this.unit.bodyWarrantyEnd);
        }
    },
    methods: {
        formatWarrantyDate(date) {
            if (date) {
                return moment(date).format('DD MMM YYYY');
            }
            return 'Unknown';
        }
    }
};
</script>
